import { render, staticRenderFns } from "./LowBalanceAlert.vue?vue&type=template&id=68a82c8e&scoped=true"
import script from "./LowBalanceAlert.vue?vue&type=script&lang=js"
export * from "./LowBalanceAlert.vue?vue&type=script&lang=js"
import style0 from "./LowBalanceAlert.vue?vue&type=style&index=0&id=68a82c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a82c8e",
  null
  
)

export default component.exports